// src/components/common/Toast.js
import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Toast.css';

function Toast({ message, image, price, quantity, packSize, action, onClose }) {
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const isHoveredRef = useRef(false);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const startTimer = useCallback(() => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      onClose();
    }, 5000);
  }, [onClose]);

  const handleMouseEnter = () => {
    isHoveredRef.current = true;
    clearTimer();
  };

  const handleMouseLeave = () => {
    isHoveredRef.current = false;
    startTimer();
  };

  useEffect(() => {
    startTimer();
    return () => clearTimer();
  }, [startTimer]);

  const getBorderColor = () => {
    switch (action) {
      case 'add':
        return 'toast-success';
      case 'remove':
        return quantity === 0 ? 'toast-error' : 'toast-warning';
      default:
        return '';
    }
  };

  const handleGoToCheckout = () => {
    navigate('/checkout');
    onClose();
  };

  return (
    <div
      className={`toast-container ${getBorderColor()}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={image} alt="Tuotekuva" className="toast-image" />
      <div className="toast-content">
        <button className="toast-dismiss" onClick={onClose} aria-label="Sulje">
          ×
        </button>
        <p className="toast-message">{message}</p>
        {typeof price === 'number' && (
          <>
            <p className="toast-price">
              Hinta: {(price * quantity).toFixed(2)} € ({price.toFixed(2)} €/pkt)
            </p>
            <p className="toast-price">
              Määrä: {quantity * packSize} kpl ({packSize} kpl/pkt)
            </p>
          </>
        )}
        <button className="toast-button" onClick={handleGoToCheckout}>
          Siirry kassalle
        </button>
      </div>
    </div>
  );
}

export default Toast;
